import React from 'react';
import moment from "moment";
import BootstrapTable from 'reactjs-bootstrap-table';
import { Pagination } from "react-bootstrap";
import { Page, PageHeader, PageBody } from "./Page";
import { translate } from './Translation';

export default class SorTable extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			sorted: this.props.data,
			originalData: this.props.data,
			searchTerm: "",
			lastSortDir: "",
			lastSortCol: "",
			per_page: this.props.per_page ? this.props.per_page : 999999,
			page: 1
		}
	}

	componentWillReceiveProps(nextProps) {
		this.setState({ originalData: nextProps.data, sorted: nextProps.data });
	}

	paginate(array, page_size, page_number) {
		--page_number; // because pages logically start with 1, but technically with 0
		return array.slice(page_number * page_size, (page_number + 1) * page_size);
	}

	onSort(colName, dir) {

		// Sort the data
		let sorted = this.sort(colName, dir, this.state.sorted);

		// Set the data and re-render
		this.setState({ sorted, lastSortDir: dir, lastSortCol: colName });
	}

	sort(colName, dir, sorted) {

		// Sort the data
		if (dir === 'asc') {
			sorted.sort(this.compare.bind({ colName, dir }));
		}
		else if (dir === 'desc') {
			sorted.sort(this.compare.bind({ colName, dir }));
		}
		else {
			sorted.sort(this.compare.bind({ colName: "id", dir: "desc" }));
		}

		return sorted;
	}

	compare(a, b) {

		let a_col = a[this.colName];
		let b_col = b[this.colName];

		if (typeof a_col === "object") {
			a_col = a_col.props.children;

			if (a_col.length > 1 && typeof a_col === "object") {
				a_col = a_col[0].props.children;
			}

			if (typeof a_col === "object") {
				a_col = a_col.props.children;
			}

		}

		if (typeof b_col === "object") {
			b_col = b_col.props.children;
			if (b_col.length > 1 && typeof b_col === "object") {
				b_col = b_col[0].props.children;
			}

			if (typeof b_col === "object") {
				b_col = b_col.props.children;
			}
		}

		if (this.colName.indexOf("date") < 0) {
			if (a_col < b_col) {
				return this.dir === "asc" ? -1 : 1;
			}
			if (a_col > b_col) {
				return this.dir === "desc" ? -1 : 1;
			}
		} else {

			let a_date = moment(a_col, "DD.MM.YYYY").toDate();
			let b_date = moment(b_col, "DD.MM.YYYY").toDate();

			if (a_date - b_date < 0) {
				return this.dir === "asc" ? -1 : 1;
			}

			if (a_date - b_date > 0) {
				return this.dir === "desc" ? -1 : 1;
			}
		}

		return 0;
	}

	normalize(text) {
		return (text + "").toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
	}

	contains(term, string) {
		const found = this.normalize(string).indexOf(this.normalize(term)) !== -1;
		// console.log("Searching", this.normalize(term), "in", this.normalize(string), found);
		return found;
	}

	search(inputData, searchTerm = null, skipSort = false) {

		// If searchterm is not defined then get it from state
		// Also else, if its not null that means we are doing search on 
		// Original data
		if (searchTerm === null) {
			searchTerm = this.state.searchTerm;
		} else {
			inputData = this.state.originalData;
		}

		// Define output data
		let outputData = [];

		// If search input is empty, then return input data
		// Else loop each input data and check for search condition,
		// if condition is met add to outputData
		if (searchTerm === "") {
			outputData = inputData;
		} else {

			outputData = inputData.filter((item) => {

				for (let key in item) {

					let column = item[key];

					// Search if string if found return true if not skip
					if (typeof column === "string" || typeof column === "number") {
						if (this.contains(searchTerm, column)) {
							return true;
						} else {
							continue;
						}
					}

					// yeah, skip boolean
					if (typeof column === "boolean") {
						continue;
					}

					// If array also ignore, but show warning for future debuging
					if (typeof column.length !== "undefined") {
						console.log("Warning! Column `", key, "` is array.");
						continue;
					}

					// So if not string it's react component
					let component = column.props.children;

					while (typeof component === "object") {
						// if length is undefined then its object not array
						if (typeof component.length === "undefined") {
							component = component.props.children;
						} else {
							// if it's array since it's not object then  get the first item
							component = component.length > 0 ? component[0] : "";
						}
					}

					//  So if the dangerous while loop finished it's job we should get searchable text
					if (this.contains(searchTerm, component)) {
						return true;
					}

				}

				return false;
			});


		}

		if (!skipSort) {
			outputData = this.sort(this.state.lastSortCol, this.state.lastSortDir, outputData);
		}

		return outputData;
	}

	onSearch(evt) {
		let searchTerm = evt.target.value.toLowerCase();

		let sorted = this.search(this.state.sorted, searchTerm);

		this.setState({ sorted, searchTerm, page: 1 });
	}

	onPageClick() {
		this.component.setState({ sorted: this.component.paginate(this.component.state.sorted, this.component.state.per_page, this.page), page: this.page });
	}

	render() {

		const itemCount = Math.ceil(this.state.sorted.length / this.state.per_page);

		const pagination = itemCount > 1 ? <Pagination prev next first last ellipsis boundaryLinks
			items={itemCount}
			maxButtons={5}
			activePage={this.state.page}
			onSelect={(eventKey) => { this.setState({ page: eventKey }); console.log(eventKey) }}
		/> : "";

		if (this.props.right) {
			return (
				<Page>
					<PageHeader title={this.props.title} right={this.props.right}>
						{this.props.search === false ? "" :
							<input type="text" placeholder={translate("Vyhľadávať")} className="form-control input-sm pull-right"
								style={{ width: (this.props.searchWidth ? this.props.searchWidth : "300px"), display: "inline-block" }}
								defaultValue={this.state.searchTerm}
								onChange={this.onSearch.bind(this)} />}
						<span className="pull-right" style={{ lineHeight: "3rem", paddingRight: "2rem" }}>
							{translate("Počet záznamov:") + " " + this.state.sorted.length}
						</span>
						{this.props.beforeSearchInput ? this.props.beforeSearchInput(this.state.sorted) : ""}
					</PageHeader>
					<PageBody>
						<BootstrapTable
							onSort={this.onSort.bind(this)}
							columns={this.props.columns}
							data={this.paginate(this.state.sorted, this.state.per_page, this.state.page)}
							headers={this.props.headers}
							tableClass="table table-hover">
							<div style={{ padding: "1rem 0", float: "right", "width": "100%" }}>{translate("Nie je čo zobraziť.")}</div>
						</BootstrapTable>
						{pagination}
					</PageBody>
				</Page>
			)
		} else {
			return (
				<div>
					{this.props.search === false ? "" :
						<input type="text" placeholder={translate("Vyhľadávať")} className="form-control"
							style={{ width: (this.props.searchWidth ? this.props.searchWidth : "300px") }}
							defaultValue={this.state.searchTerm}
							onChange={this.onSearch.bind(this)} />}
					<BootstrapTable
						onSort={this.onSort.bind(this)}
						columns={this.props.columns}
						data={this.paginate(this.state.sorted, this.state.per_page, this.state.page)}
						headers={this.props.headers}
						tableClass="table table-hover"
					>
						<div style={{ padding: "1rem 0" }}>{translate("Nie je čo zobraziť.")}</div>
					</BootstrapTable>
					{pagination}
				</div>
			)
		}
	}

}


// WEBPACK FOOTER //
// ./src/modules/base/SorTable.js